import { useEffect, useState } from "react";

const navLinks = [
  { href: "#categories", label: "CP分类" },
  { href: "#hot", label: "热门推荐" },
  { href: "#guide", label: "阅读指南" },
  { href: "#about", label: "关于我们" },
  { href: "#faq", label: "常见问题" },
  { href: "#contact", label: "联系我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md shadow-sm border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 w-full items-center justify-between px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-full ${
              scrolled ? "bg-primary-500" : "bg-background-50/20"
            } text-background-50`}
          >
            <i className="ri-ink-bottle-line text-lg"></i>
          </span>
          <span
            className={`font-display text-xl tracking-wide ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            火影同人本子
          </span>
        </a>

        <div className="hidden items-center gap-7 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`text-sm whitespace-nowrap transition-colors hover:text-primary-500 ${
                scrolled ? "text-foreground-700" : "text-background-50/90"
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            className={`whitespace-nowrap rounded-md px-5 py-2 text-sm font-medium text-background-50 transition-colors ${
              scrolled ? "bg-primary-500 hover:bg-primary-600" : "bg-background-50/20 hover:bg-background-50/30"
            }`}
          >
            开始探索
          </a>
        </div>

        <button
          type="button"
          aria-label="展开菜单"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-md lg:hidden ${
            scrolled ? "text-foreground-900" : "text-background-50"
          }`}
        >
          <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="flex flex-col gap-1 px-4 py-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-secondary-100"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50 hover:bg-primary-600"
            >
              开始探索
            </a>
          </div>
        </div>
      )}
    </header>
  );
}